import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

const AdminNavbar = () => {
  const { isAuthenticated, user, logout } = useAuth0();
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (isAuthenticated && user?.email) {
      fetch("https://snapcourse.in/contentapi/diary/verify-admin.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: user.email }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.isAdmin) {
            setIsAdmin(true);
          } else {
            navigate("/"); // Redirect if not an admin
          }
        })
        .catch(error => {
          console.error("Error verifying admin:", error);
          navigate("/"); // Redirect on error
        });
    } else {
      navigate("/"); // Redirect if not authenticated
    }
  }, [isAuthenticated, user, navigate]);

  return isAdmin ? (
    <>
    {/* // <nav className="navbar"> */}
      {/* <ul className="navbar-list"> */}
        {/* <li className="navbar-item"> */}
          {/* <Link to="/admindashboard">Dashboard</Link> */}
        {/* </li> */}
        {/* <li className="navbar-item"> */}
          {/* <Link to="/createcontent">Create Content</Link> */}
        {/* </li> */}
        {/* <li className="navbar-item">Show Content</li> */}
        {/* <li className="navbar-item">Edit Content</li> */}
        {/* <li className="navbar-item">Manage Admin</li> */}
        {/* <li className="navbar-item" onClick={() => logout({ returnTo: window.location.origin })}> */}
          {/* Logout */}
        {/* </li> */}
      {/* </ul> */}
    {/* </nav> */}
    </>
  ) : null; // Hide navbar if not an admin
};

export default AdminNavbar;
